
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course/[[...courseFilter]]",
      function () {
        return require("private-next-pages/course/[[...courseFilter]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course/[[...courseFilter]]"])
      });
    }
  